import SOUNDS from 'sounds'

export const TOOLBAR_CHOOSE_TYPE = 'reserve_activation/CHOOSE_TYPE'
export const TOOLBAR_CHOOSE_TOOLTIP_TYPE = 'reserve_activation/CHOOSE_TOOLTIP_TYPE'
export const TOOLBAR_POPOVER_OPENED = 'reserve_activation/POPOVER_OPENED'
export const TOOLBAR_POPOVER_CLOSED = 'reserve_activation/POPOVER_CLOSED'


export function chooseReserveType(reserveType) {
    return {
        type: TOOLBAR_CHOOSE_TYPE,
        payload: {
            reserveType,
        },
    }
}

export function chooseTooltipReserveType(reserveType) {
    const meta = {}
    if (reserveType) {
        meta.webToClient = {
            handler: 'playSound',
            params: { soundId: SOUNDS.HOVER },
        }
    }

    return {
        type: TOOLBAR_CHOOSE_TOOLTIP_TYPE,
        payload: {
            reserveType,
        },
        meta,
    }
}

export function setPopoverOpenedFlag() {
    return {
        type: TOOLBAR_POPOVER_OPENED,
        payload: {},
    }
}

export function setPopoverClosedFlag() {
    return {
        type: TOOLBAR_POPOVER_CLOSED,
        payload: {},
    }
}



// WEBPACK FOOTER //
// ./state/actions/toolbar.js